import { useCallback } from 'react';
import { useNotifications, useSuspensions } from '@personly/libs-providers';
import { deploymentUrl } from '@personly/libs-urls';
import { useResources } from '@/providers/resources';
const useTickets = () => {
  const {
    createNotification
  } = useNotifications();
  const {
    createSuspension,
    removeSuspension
  } = useSuspensions();
  const resources = useResources();
  const createTicket = useCallback(async (email: string, body: string, type: string, locale: string, cb: (handle: string) => void) => {
    try {
      createSuspension('CREATE_TICKET');
      const url = deploymentUrl('/agon/v1/guest/createTicket');
      const data = new URLSearchParams();
      data.set('body', body);
      data.set('email', email);
      data.set('type', type);
      data.set('locale', locale);
      const options = {
        method: 'POST',
        body: data
      };
      const {
        result
      } = await resources<string>(url, options);
      cb(result);
    } catch (e) {
      if (e instanceof Error) {
        const handle = e.message ?? 'ERROR';
        createNotification('ERROR', handle);
      }
    } finally {
      removeSuspension('CREATE_TICKET');
    }
  }, [createNotification, createSuspension, removeSuspension, resources]);
  return {
    createTicket
  };
};
export default useTickets;